import React from 'react'
import { SnopCreateGroups } from "@auteco/pages"

const SnopCreateGroupsContainer = () => {
    return (
        <SnopCreateGroups />
    )
}

export { SnopCreateGroupsContainer }